import { createContext, useContext } from 'react';

/** When true, ContextItem uses the compact grid size (95px), including image previews. */
export const ContextItemGridContext = createContext(false);

export const useContextItemGrid = () => useContext(ContextItemGridContext);
